export function downloadBlob(blob,name){
 const url=URL.createObjectURL(blob),a=document.createElement("a");
 a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();
 setTimeout(()=>URL.revokeObjectURL(url),30000);
}
export function equalPower(value){
 if(!Number.isFinite(value)||value<0||value>1)throw new Error("Cruce inválido");
 return [Math.cos(value*Math.PI/2),Math.sin(value*Math.PI/2)];
}
export function comparePixels(a,b,threshold=20){
 if(a.length!==b.length||a.length%4||!a.length)throw new Error("Imágenes de tamaños distintos");
 if(!Number.isFinite(threshold)||threshold<0||threshold>255)throw new Error("Umbral inválido");
 const pixels=new Uint8ClampedArray(a.length);let changed=0;
 for(let i=0;i<a.length;i+=4){
  const delta=(Math.abs(a[i]-b[i])+Math.abs(a[i+1]-b[i+1])+Math.abs(a[i+2]-b[i+2])+Math.abs(a[i+3]-b[i+3]))/4;
  if(delta>threshold){pixels[i]=255;pixels[i+1]=70;pixels[i+2]=70;changed++}
  else{pixels[i]=a[i]*.4;pixels[i+1]=a[i+1]*.4;pixels[i+2]=a[i+2]*.4}
  pixels[i+3]=255;
 }
 return {pixels,changed,total:a.length/4,percent:Math.round(changed/(a.length/4)*10000)/100};
}
export function estimateBpm(samples,sampleRate){
 if(!samples.length||!Number.isFinite(sampleRate)||sampleRate<8000)throw new Error("Audio inválido");
 const hop=Math.max(1,Math.floor(sampleRate/100)),count=Math.min(6000,Math.floor(samples.length/hop));
 if(count<500)return {bpm:null,confidence:0};
 const energy=new Float64Array(count);
 for(let i=0;i<count;i++){let sum=0;for(let k=0;k<hop;k++)sum+=samples[i*hop+k]**2;energy[i]=Math.sqrt(sum/hop)}
 let max=0;const onset=new Float64Array(count);
 for(let i=1;i<count;i++){onset[i]=Math.max(0,energy[i]-energy[i-1]);max=Math.max(max,onset[i])}
 if(max<.00001)return {bpm:null,confidence:0};
 let best=0,bestLag=0,all=0,tries=0;
 for(let lag=34;lag<=100;lag++){let score=0;for(let i=lag;i<count;i++)score+=onset[i]*onset[i-lag];score/=count-lag;all+=score;tries++;if(score>best){best=score;bestLag=lag}}
 if(!best)return {bpm:null,confidence:0};
 return {bpm:Math.round(6000/bestLag),confidence:Math.min(1,Math.max(0,1-(all/tries)/best)),method:"Autocorrelación; revisar mitad/doble tempo"};
}
function once(target,event,timeout=8000){
 return new Promise((resolve,reject)=>{
  const clear=()=>{clearTimeout(timer);target.removeEventListener(event,ok);target.removeEventListener("error",fail)};
  const ok=()=>{clear();resolve()},fail=()=>{clear();reject(new Error("No se puede leer este archivo"))};
  const timer=setTimeout(()=>{clear();reject(new Error("Tiempo de lectura agotado"))},timeout);
  target.addEventListener(event,ok,{once:true});target.addEventListener("error",fail,{once:true});
 });
}
export async function videoMosaic(file){
 if(!file||!file.type.startsWith("video/")||file.size>50*1024*1024)throw new Error("Elegí un video de hasta 50 MB");
 const video=document.createElement("video"),url=URL.createObjectURL(file);
 video.muted=true;video.playsInline=true;video.preload="auto";
 try{
  const ready=once(video,"loadeddata");video.src=url;video.load();await ready;
  if(!Number.isFinite(video.duration)||video.duration<.2||video.duration>600)throw new Error("Elegí un video de hasta diez minutos");
  const canvas=document.createElement("canvas");canvas.width=1280;canvas.height=720;const ctx=canvas.getContext("2d");
  ctx.fillStyle="#061224";ctx.fillRect(0,0,1280,720);
  const times=[];
  for(let i=0;i<6;i++){
   const stamp=video.duration*(.05+i*.18),seek=once(video,"seeked");video.currentTime=stamp;await seek;
   const x=(i%2)*640,y=Math.floor(i/2)*240,scale=Math.min(640/video.videoWidth,210/video.videoHeight),w=video.videoWidth*scale,h=video.videoHeight*scale;
   ctx.drawImage(video,x+(640-w)/2,y,w,h);ctx.fillStyle="white";ctx.font="20px sans-serif";ctx.fillText(stamp.toFixed(2)+" s",x+12,y+230);times.push(Number(stamp.toFixed(2)));
  }
  return {image_b64:canvas.toDataURL("image/jpeg",.8).split(",")[1],duration:video.duration,times};
 }finally{video.pause();video.removeAttribute("src");video.load();URL.revokeObjectURL(url)}
}
export async function imagePixels(file,width=512,height=384){
 if(!file||!["image/png","image/jpeg","image/webp"].includes(file.type)||file.size>5*1024*1024)throw new Error("Elegí PNG, JPEG o WebP de hasta 5 MB");
 const url=URL.createObjectURL(file),image=new Image();
 try{
  const ready=once(image,"load");image.src=url;await ready;
  if(image.naturalWidth*image.naturalHeight>16000000)throw new Error("Máximo 16 megapíxeles");
  const canvas=document.createElement("canvas");canvas.width=width;canvas.height=height;const ctx=canvas.getContext("2d");
  const ratio=Math.min(width/image.naturalWidth,height/image.naturalHeight);
  ctx.drawImage(image,(width-image.naturalWidth*ratio)/2,(height-image.naturalHeight*ratio)/2,image.naturalWidth*ratio,image.naturalHeight*ratio);
  return {canvas,pixels:ctx.getImageData(0,0,width,height).data,original:{width:image.naturalWidth,height:image.naturalHeight}};
 }finally{URL.revokeObjectURL(url)}
}
